import React from 'react';
import { ChefHat, Leaf, Award, Users } from 'lucide-react';
import { features } from '../data/mockData';

const About = () => {
  const icons = {
    0: Leaf,
    1: ChefHat,
    2: Award,
    3: Users
  };

  return (
    <section id="about" className="py-20 bg-gradient-to-b from-white to-yellow-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            About <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-pink-500">Ambarsariya</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-yellow-400 to-pink-400 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Bringing the authentic flavors of North India to your table with a perfect blend 
            of tradition and taste. Every dish tells a story of Punjab's rich culinary heritage.
          </p>
        </div>

        {/* Story Section */}
        <div className="mb-16 bg-white rounded-2xl shadow-lg p-8 md:p-12">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-800 mb-6">Our Story</h3>
              <p className="text-gray-600 mb-4 leading-relaxed">
                The name Ambarsariya is inspired by Ambarsar, the historic and old name of Amritsar. 
                Ambarsariya is more than just a restaurant – it's a celebration of North Indian 
                vegetarian cuisine. We bring together the authentic flavors of Punjab, the vibrant 
                street food culture of Mumbai, and the iconic chaat delicacies of Delhi.
              </p>
              <p className="text-gray-600 mb-4 leading-relaxed">
                Our tandoor-baked specialties, aromatic curries, and mouthwatering street food 
                are prepared using traditional recipes passed down through generations, ensuring 
                every bite is an authentic experience.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Whether you're craving the smoky flavors of tandoori paneer tikka, the tangy 
                explosion of golgappe, or the rich comfort of dal makhani with laccha paratha, 
                Ambarsariya promises a culinary journey through North India.
              </p>
            </div>
            <div className="flex items-center justify-center">
              <img
                src="https://customer-assets.emergentagent.com/job_6155f013-7394-403e-8ef1-e61234cc182e/artifacts/txxz08be_Ambarsariya_Logo%20Design-JPEG%20-%202.jpg"
                alt="Ambarsariya - The Taste of Amritsar"
                className="w-full h-96 object-contain"
              />
            </div>
          </div>
        </div>

        {/* Features Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => {
            const Icon = icons[index];
            return (
              <div
                key={feature.id}
                className="group bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-yellow-400"
              >
                <div className="mb-4">
                  <div className="w-14 h-14 bg-gradient-to-br from-yellow-100 to-pink-100 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform">
                    <Icon className="w-7 h-7 text-yellow-600" />
                  </div>
                </div>
                <h4 className="text-xl font-bold text-gray-800 mb-3">{feature.title}</h4>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            );
          })}
        </div>

        {/* Special Note */}
        <div className="mt-12 bg-gradient-to-r from-yellow-400 to-pink-400 rounded-2xl p-8 text-center">
          <p className="text-gray-800 font-semibold text-lg">
            🌱 Without Onion & Garlic options available | ⏱️ Order will take minimum 15 mins to serve
          </p>
          <p className="text-gray-700 mt-2">
            💚 5% GST Extra | 🍳 Medium of Cooking (Butter, Ghee, Sunflower Oil)
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
